// extracted by mini-css-extract-plugin
module.exports = {"actionButtonsContainer":"ReferralSources_actionButtonsContainer__2l8Xs","actionColumn":"ReferralSources_actionColumn__2_JUt","textButton":"ReferralSources_textButton__fBSU1"};